import '@capturi/ui-components/styled-system/styles.css'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { CapturiThemeProvider } from './CapturiThemeProvider'
import { messages as messagesDa } from './locales/da/messages.mjs'
import { messages as messagesEn } from './locales/en/messages.mjs'
import { UnsubscribePage } from './pages/UnsubscribePage'

const lang = new URLSearchParams(window.location.search).get('language') ?? 'en'
const messages = {
  da: messagesDa,
  en: messagesEn,
}
i18n.load(messages)
const activatingLang = Object.keys(messages).includes(lang) ? lang : 'en'
i18n.activate(activatingLang)

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

ReactDOM.createRoot(root).render(
  <StrictMode>
    <CapturiThemeProvider>
      <I18nProvider i18n={i18n}>
        <UnsubscribePage />
      </I18nProvider>
    </CapturiThemeProvider>
  </StrictMode>,
)
